const setRecSessionData = (data) => {
    return {
        type: "SET_REC_SESSION_DATA",
        payload: data
    }
}

export default {
    setRecSessionData
}